/**
 * Created by razial on 30.07.2024.
 */

const DynamiteView = function (dynamite, unitView) {
    this.dynamite = dynamite;
    this.unitView = unitView;
};

DynamiteView.prototype.explode = function () {
    this.unitView.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode(this.unitView), {
        keepScale: true
    });
    this.unitView.sprite.setAnimation(0, "explode", false);
    this.unitView.sprite.setCompleteListener(() => {
        this.unitView.removeFromParent();
    });
};